


















































































import Vue from 'vue'
import ServerPaginationList from '@/components/ServerPaginationList.vue'
import ItemCard from '@/components/project/ItemCard.vue'
import PagedResults from '@/service/PagedResults'
import { ContestWinner } from '@/model/ContestWinner'
import { Contest } from '@/model/Contest'

export default Vue.extend({
  name: 'UserContests',
  components: {
    ServerPaginationList,
    ItemCard,
  },
  props: {
    userId: {
      type: String,
    },
  },
  mounted() {
    this.fetchWinners()
  },
  computed: {
    winnersGrouped: function (): Record<string, ContestWinner[]> {
      const result = {} as Record<string, ContestWinner[]>
      for (let i = 0; i < this.winners.length; i++) {
        const winner = this.winners[i]
        const contest = winner.contest as Contest
        if (!contest['@id']) {
          continue
        }
        if (!(contest['@id'] in result)) {
          result[contest['@id']] = []
        }
        result[contest['@id']].push(winner)
      }
      return result
    },
  },
  data: () => ({
    winners: [] as ContestWinner[],
  }),
  methods: {
    fetchWinners: function () {
      const winnersLoader = new PagedResults<ContestWinner[]>(this.$api)
      winnersLoader
        .all(this.userId + '/contest_winners', 30)
        .then((result) => (this.winners = result))
    },
  },
  watch: {
    userId: function () {
      this.fetchWinners()
    },
  },
})
